(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDeleteController',IssueSignificanceDeleteController);

    IssueSignificanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'IssueSignificance'];

    function IssueSignificanceDeleteController($uibModalInstance, entity, IssueSignificance) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IssueSignificance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
